import type { IBaseComponentProps } from 'components/base/types'
import { Grid } from 'components/grid'
import { clip } from '@/utils/string'
import { tv } from 'tailwind-variants'
import { computed, defineComponent, type FunctionalComponent } from 'vue'

const clazz = tv({
  slots: {
    base: 'cursor-pointer hover:opacity-80',
    iconWrapper:
      'w-10 h-10 bg-gray-100 text-gray-400 flex items-center content-center justify-center overflow-hidden',
    title: 'text-gray-900 font-semibold',
    subtitle: 'text-gray-500'
  },
  variants: {
    size: {
      s: {
        iconWrapper: 'w-5 h-5',
        title: 'text-xs',
        subtitle: 'text-xs'
      },
      xs: {
        iconWrapper: 'w-2 h-2'
      }
    }
  }
})

type IGenericDisplayProps = IBaseComponentProps & {
  image: FunctionalComponent;
  title: string;
  subtitle?: string;
  size?: 'xs' | 's' | 'm' | 'l'
  withName?: boolean
}
export const GenericDisplay = defineComponent<IGenericDisplayProps>(
  (props) => {
    const classes = clazz({ size: props.size as any })
    const layout = computed(() => (props.withName === false ? 'max-content' : 'max-content auto'))
    return () => {
      return (
        <Grid class={classes.base({})} columns={layout.value} alignItems="center" gap="0.5rem">
          <div class={classes.iconWrapper({})}>
            <props.image/>
          </div>
          {props.withName !== false && (
            <Grid noDefaultLayout rows={props.subtitle ? "max-content max-content" : "max-content"}>
              <div class={classes.title({})}>{clip(props.title, 32)}</div>
              {props.subtitle && <div class={classes.subtitle({})}>
                {props.subtitle}
              </div> }
            </Grid>
          )}
        </Grid>
      )
    }
  },
  { props: ['title', 'subtitle', 'size', 'withName', 'image'] }
)
